package hk.com.vr360_demo2.webapp.component.common

import react.RefObject
import web.html.HTMLDivElement
import kotlin.math.abs

private const val HORIZONTAL_DRAG_CLICK_THRESHOLD_PX = 5

fun HTMLDivElement.attachHorizontalDragScroll(dragDidMoveRef: RefObject<Boolean>): () -> Unit {
    var pointerActive = false
    var dragging = false
    var startX = 0.0
    var scrollStart = 0.0

    val endPointer = fun(e: dynamic) {
        if (!pointerActive) return
        pointerActive = false
        if (dragging) {
            dragging = false
            asDynamic().style.cursor = "grab"
            try {
                releasePointerCapture(e.pointerId)
            } catch (_: dynamic) {
            }
        }
    }

    val onPointerDown = fun(e: dynamic) {
        val button = e.button as? Int
        if (button != null && button != 0) return
        if (scrollWidth <= clientWidth + 1) return
        pointerActive = true
        dragging = false
        dragDidMoveRef.current = false
        startX = e.clientX as Double
        scrollStart = scrollLeft
    }

    val onPointerMove = fun(e: dynamic) {
        if (!pointerActive) return
        val dx = (e.clientX as Double) - startX
        if (!dragging) {
            if (abs(dx) <= HORIZONTAL_DRAG_CLICK_THRESHOLD_PX) return
            dragging = true
            dragDidMoveRef.current = true
            asDynamic().style.cursor = "grabbing"
            try {
                setPointerCapture(e.pointerId)
            } catch (_: dynamic) {
            }
        }
        scrollLeft = scrollStart - dx
    }

    asDynamic().addEventListener("pointerdown", onPointerDown)
    asDynamic().addEventListener("pointermove", onPointerMove)
    asDynamic().addEventListener("pointerup", endPointer)
    asDynamic().addEventListener("pointercancel", endPointer)

    return {
        asDynamic().removeEventListener("pointerdown", onPointerDown)
        asDynamic().removeEventListener("pointermove", onPointerMove)
        asDynamic().removeEventListener("pointerup", endPointer)
        asDynamic().removeEventListener("pointercancel", endPointer)
    }
}
